import {Member} from "@/store/api/memberApi";
import {createSlice, PayloadAction} from "@reduxjs/toolkit";

interface MemberFormData {
    complete: boolean;
    data: Member | null
}

interface MemberState{
    memberFormData: MemberFormData[];
    memberData: Member[] | null;
}

const initialState: MemberState = {
    memberFormData: [
        {complete: false, data: null}
    ],
    memberData: null
}

const memberSlice = createSlice({
    name: 'member',
    initialState,
    reducers: {
        addMember: (state) => {
            state.memberFormData.push({complete: false, data: null});
        },
        deleteMember: (state, action) => {
            state.memberFormData.splice(action.payload, 1);
        },
        saveMember: (state, action) => {
            const index = action.payload.index;
            const data = action.payload.data;
            state.memberFormData[index] = {complete: true, data: data}
        },
        updateMember: (state, action) => {
            const index = action.payload;
            if (state.memberFormData[index]) {
                state.memberFormData[index].complete = false;
            }
        },
        setMember: (state, action: PayloadAction<Member[]>) => {
            state.memberData = action.payload
        }
    }
})

export const {
    addMember,
    deleteMember,
    saveMember,
    updateMember,
    setMember
} = memberSlice.actions;

export default memberSlice.reducer;

